import { DOCUMENT_TYPE } from '../../../../../pages/core/models/User';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../../../../pages/core/abstraction/auth.service';
import { DOCUMENT_ERRORS } from '../../../../../pages/core/models/User';
import { AlertDialogComponent, AlertDialogData } from '../alert-dialog/alert-dialog.component';

export interface UploadImageDialogData {
  title: string;
  body: string;
  options: string[];
  documentType: DOCUMENT_TYPE;
  successMessage: string;
  disableComment?: boolean;
}

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss'],
})
export class UploadImageComponent implements OnInit {
  @ViewChild('fileUploadInput') fileUploadInput;
  imageUrl = '';
  imageShown: string;
  passportImage: File;
  changedImage = false;
  imageErrorMessage = '';
  loading = false;
  uploadSuccess = false;
  loadingMessage: string;
  fileBase64: string;
  textComment = '';

  constructor(
    private auth: AuthService,
    public dialogRef: MatDialogRef<UploadImageComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: UploadImageDialogData,
  ) {}

  onNoClick(): void {
    this.dialogRef.close(this.uploadSuccess);
  }

  ngOnInit() {
    this.loading = false;
  }

  readImage(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target.files && target.files[0]) {
      this.passportImage = target.files[0];
      this.changedImage = true;

      const reader = new FileReader();
      reader.onload = (onloadEvent: ProgressEvent) => {
        const acceptedExtension = ['bmp', 'jpg', 'jpeg', 'pdf', 'png', 'tif', 'tiff'];
        const extension = target.files[0].name.split('.').pop().toLowerCase();
        const progressTarget = onloadEvent.target as FileReader;
        this.fileBase64 = progressTarget.result as string;
        // Check de tamaño 25 MB
        // console.log(onloadEvent.total, extension, acceptedExtension.indexOf(extension));
        if (onloadEvent.total > 26300000 || acceptedExtension.indexOf(extension) === -1) {
          this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
            panelClass: 'modal-container',
            data: {
              title: 'Error en subir archivo',
              content:
                'El tamaño máximo permitido es de 25 MB. Los formatos válidos son bmp, jpg, jpeg, pdf, png, tif, tiff.',
              isError: true,
            },
          });
          return;
        }
        // Result image
        if ((progressTarget.result as string).substring(0, 20) === 'data:application/pdf') {
          this.imageShown = 'assets/images/pdf.svg';
        } else {
          this.imageShown = progressTarget.result as string;
        }
      };
      reader.onerror = (err) => {
        console.log(err);
        this.passportImage = undefined;
        this.changedImage = false;
        this.imageErrorMessage = 'File is not an image';
        target.value = '';
        setTimeout(() => (this.imageErrorMessage = ''), 5000);
      };
      reader.readAsDataURL(target.files[0]);
    }
  }

  uploadImage() {
    if (this.loading) return;

    this.loadingMessage = 'Subiendo imagen...';
    this.loading = true;
    this.dialogRef.disableClose = true;
    this.auth.uploadImage(this.data.documentType, this.fileBase64, this.textComment).subscribe(
      () => {
        this.uploadSuccess = true;
        this.loadingMessage = this.data.successMessage;
      },
      (err: HttpErrorResponse) => {
        this.dialogRef.disableClose = false;

        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.loadingMessage = this.setErrorUploadDocument(err.error.internalStatus as string);

        setTimeout(() => {
          this.loading = false;
        }, 4000);
      },
    );
  }

  triggerUploadImage() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    this.fileUploadInput.nativeElement.click();
  }

  setErrorUploadDocument(error: string) {
    switch (error) {
      case DOCUMENT_ERRORS.REPEATED_DOCUMENTATION:
        return 'Ya subiste esta documentación anteriormente. Probá con una nueva.';
      case DOCUMENT_ERRORS.USER_BLOCKED:
        return 'No es posible subir el documento. Por seguridad, su usuario ha sido bloqueado, debe contactar a compliance@tiendacrypto.com.';
      case DOCUMENT_ERRORS.TOO_MANY_PENDING:
        return 'Llegaste al límite de documentaciones subidas, por favor esperá la resolución de alguna de las que subiste. ';
      default:
        return 'Ocurrió un problema en la subida de la imagen, intente nuevamente.';
    }
  }
}
